import get from "lodash.get"
import { useEffect } from "react"
import { useSelector } from "react-redux"

// hook to check if the system is listening by checking the state of the redux store
export default function useIsListening() {

    const isListening = useSelector(state => get(state, 'speech.listener.isListening', null))

    useEffect (() => {
        if(!isListening) console.log("🔴 Not listening")
        else console.log("🟢 Listening")
    }, [isListening])

    return isListening
}